import Vue from 'vue';
import { mountVue } from 'utils/vueContainer';

// All Vue components
import HeaderComponent from 'components/HeaderComponent';
import AccordionComponent from 'components/AccordionComponent';
import SliderComponent from 'components/SliderComponent';
import HomeAnimationComponent from 'components/HomeAnimationComponent';
import SiteNameComponent from 'components/SiteNameComponent';
import filterableList from '@y7k/component-filterable-list';
import FilterFieldIncrementer from 'components/filterFieldIncrementer/filterFieldIncrementer';
import ReflineJobs from 'components/ReflineJobs';


// ------------------------------------------------------------------------
// Boot App
// ------------------------------------------------------------------------
require('boot');

// ------------------------------------------------------------------------
// Enable Barba.js Page Transitions
// ------------------------------------------------------------------------
require('transitions');

// ------------------------------------------------------------------------
// Register Vue Components
// ------------------------------------------------------------------------
Vue.component('header-component', HeaderComponent);
Vue.component('accordion-component', AccordionComponent);
Vue.component('home-animation-component', HomeAnimationComponent);
Vue.component('site-name-component', SiteNameComponent);
Vue.component('slider-component', SliderComponent);
Vue.component('refline-jobs', ReflineJobs);

filterableList.registerGlobally();
Vue.component('filter-field-incrementer', FilterFieldIncrementer);

// ------------------------------------------------------------------------
// Mount Vue Instances (outside of Barba container)
// ------------------------------------------------------------------------
mountVue('.js-vueContainer', document);

// ------------------------------------------------------------------------
// Triggers once the app has been launched
// ------------------------------------------------------------------------
document.addEventListener('AppReady', () => {
    document.documentElement.classList.remove('no-fouc');
});

// ------------------------------------------------------------------------
// Launch the app
// ------------------------------------------------------------------------
if (document.readyState === 'complete') {
    document.dispatchEvent(new CustomEvent('AppReady'));
} else {
    document.addEventListener('DOMContentLoaded', () => {
        document.dispatchEvent(new CustomEvent('AppReady'));
    });
}
